import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { LoaderComponent } from './loader/loader.component';
import { MasterTabListComponent } from './master-tab-list/master-tab-list/master-tab-list.component';
import { MasterTabComponent } from './master-tab/master-tab/master-tab.component';
import { NotResultFoundComponent } from './not-result-found/not-result-found.component';
import { MyFilterPipe } from './shared/pipes/my-filter.pipe';
import { StatusModalComponent } from './order/status-modal/status-modal.component';
import { ZingchartAngularModule } from 'zingchart-angular';
import { TrackerComponent } from './attendence/tracker/tracker.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MaterialModule } from './material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule, MatDialogModule, MatProgressSpinnerModule, MatSliderModule } from '@angular/material';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { RedeemStatusModalComponent } from './redeem-status-modal/redeem-status-modal.component';
import { ImageModuleComponent } from './image-module/image-module.component';
import { OrderDetailComponent } from './order/order-detail/order-detail.component';
import { AgmCoreModule } from '@agm/core';
import { DistributionDetailComponent } from './distribution/distribution-detail/distribution-detail.component';
import { LeadDetailComponent } from './lead/lead-detail/lead-detail.component';
import { RouterModule } from '@angular/router';
import { RedeemRequestDetailComponent } from './redeem/redeem-request-detail/redeem-request-detail.component';
import { InfluencerDetailComponent } from './Influencer/influencer-detail/influencer-detail.component';
import { BillingDetailComponent } from './billing-detail/billing-detail.component';
// import { SalesReturnListComponent } from './sales-return/sales-return-list/sales-return-list.component';
import { CouponCodeAddComponent } from './coupon/coupon-code-add/coupon-code-add.component';
import { CouponCodeDetailComponent } from './coupon/coupon-code-detail/coupon-code-detail.component';
import { ReplacementComponent } from './coupon/replacement/replacement.component'
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { GatepassAddComponent } from './company-dispatch/gatepass-add/gatepass-add.component';
import { SecondaryOrderDetailComponent } from './order/secondary-order-detail/secondary-order-detail.component';
import { DesignationComponent } from './user/designation/designation.component';
import { AddDistributionComponent } from './distribution/add-distribution/add-distribution.component';
import { BottomSheetComponent } from './bottom-sheet/bottom-sheet.component';
import { SecondaryOrderListComponent } from './order/secondary-order-list/secondary-order-list.component';
import { UserviewTargetModalComponent } from './userview-target/userview-target-modal.component';
import { TravelListComponent } from './travel/travel-list/travel-list.component';


@NgModule({
  declarations: [
    TravelListComponent,
    NotResultFoundComponent,
    UserviewTargetModalComponent,
    LoaderComponent,
    TrackerComponent,
    AddDistributionComponent,
    MyFilterPipe,
    MasterTabComponent,
    MasterTabListComponent,
    StatusModalComponent,
    DesignationComponent,
    RedeemStatusModalComponent,
    ImageModuleComponent,
    DistributionDetailComponent,
    SecondaryOrderListComponent,
    LeadDetailComponent,
    RedeemRequestDetailComponent,
    InfluencerDetailComponent,
    OrderDetailComponent,
    SecondaryOrderDetailComponent,
    BillingDetailComponent,
    CouponCodeAddComponent,
    // SalesReturnListComponent,
    GatepassAddComponent,
    CouponCodeDetailComponent,
    ReplacementComponent,
    BottomSheetComponent

],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAZ-kqYo3DslRI2VIuvP5GIK7OK-U9n3AQ'
      /* apiKey is required, unless you are a
      premium customer, in which case you can
      use clientId
      */
  }),
    CommonModule,
    FilterPipeModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule, 
    NgMultiSelectDropDownModule,
    MaterialModule,
    AutocompleteLibModule,
    MatIconModule,
    MatSliderModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    NgxMatSelectSearchModule,
    NgxBarcodeModule,
    NgxQRCodeModule, 
    ZingchartAngularModule,
  ],
  exports:[
    NotResultFoundComponent,
    LoaderComponent,
    MyFilterPipe,
    FilterPipeModule,
    MasterTabComponent,
    MasterTabListComponent,
    DistributionDetailComponent,
    LeadDetailComponent,
    InfluencerDetailComponent,
    SecondaryOrderListComponent,
    OrderDetailComponent,
    TrackerComponent,
  ],
  entryComponents:[TravelListComponent,UserviewTargetModalComponent,StatusModalComponent, RedeemStatusModalComponent, ImageModuleComponent,DesignationComponent, BottomSheetComponent]
  
})
export class AppUtilityModule { }
